module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("ZONDERVAN")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Present Perfect")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Copyright © 2010 by Gregory A. Boyd"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All rights reserved under International and Pan-American Copyright Conventions. By payment of the required fees, you have been granted the non-exclusive, non-transferable right to access and read the text of this e-book on-screen. No part of this text may be reproduced, transmitted, down-loaded, decompiled, reverse engineered, or stored in or introduced into any information storage and retrieval system, in any form or by any means, whether electronic or mechanical, now known or hereinafter invented, without the express written permission of Zondervan."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ePub Edition MARCH 2010 ISBN: 978-0-310-56062-3"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Requests for information should be addressed to: Zondervan, "), _c('i', [_vm._v("Grand Rapids, Michigan 49530")]), _c('br'), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Boyd, Gregory A., 1957-")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Present perfect: discovering God’s kingdom in the now / Gregory A. Boyd.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("p. cm.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Includes bibliographical references (p. 163)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ISBN 978-0-310-28384-3 (softcover)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1. Spiritual life—Christianity. I. Title.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("BV4501.3.B693 2010")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("248.4-dc22")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("2010001878")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This title is also available in a Zondervan audio edition. Visit "), _c('a', {
    attrs: {
      "href": "http://www.zondervan.fm",
      "target": "_blank"
    }
  }, [_vm._v("www.zondervan.fm")]), _vm._v("."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All Scripture quotations, unless otherwise indicated, are taken from the Holy Bible, "), _c('i', [_vm._v("New International Version®, NIV®.")]), _vm._v(" Copyright © 1973, 1978, 1984 by Biblica, Inc.™ Used by permission of Zondervan. All rights reserved worldwide."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The song “Time” by Roger Waters is used by permission of Hampshire House Publishing. All rights reserved."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Any Internet addresses (websites, blogs, etc.) and telephone numbers printed in this book are offered as a resource. They are not intended in any way to be or imply an endorsement by Zondervan, nor does Zondervan vouch for the content of these sites and numbers for the life of this book."), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a94557b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005copyright.vue
// module id = 69
// module chunks = 0